import { useId as useReactId } from "react";

function useId(id?: string): string {
    const uniqueId = useReactId();

    if (id) {
        return id;
    }

    return uniqueId;
}

export default useId;
